<template>
  <b-form id="tags-info" @submit.prevent="onSubmitForm">
    <b-row class="tags-info">
      <b-col cols="12">
        <b-card no-body class="mb-1 pb-4 container-card">
          <div class="row px-5">
            <div class="col-12">
              <div class="row">
                <div class="col-md-12">
                  <div class="row">
                    <div class="col-md-6 mt-4">
                      <div>
                        <b-form-group
                          :label="'Reference'"
                          label-for="'tag-ref"
                          label-class="font-medium-5"
                          class=""
                        >
                          <b-form-input
                            id="tag-ref"
                            v-model="tagsInfoData.Reference"
                            disabled
                          />
                        </b-form-group>
                        <b-form-group
                          :label="'Tag Name'"
                          label-for="'tag-name"
                          label-class="font-medium-5 required"
                        >
                          <b-form-input
                            id="tag-name"
                            v-model="tagsInfoData.TagsName"
                            required
                            :formatter="onInputTagName"
                          />
                        </b-form-group>
                        <b-form-group
                          :label="'String Value'"
                          label-for="'string-value"
                          label-class="font-medium-5"
                          class=""
                        >
                          <b-form-input
                            id="string-value"
                            v-model="tagsInfoData.StringValue"
                          />
                        </b-form-group>
                        <b-form-group
                          :label="'Int Value'"
                          label-for="'int-value"
                          label-class="font-medium-5"
                          class=""
                        >
                          <b-form-input
                            id="int-value"
                            v-model="tagsInfoData.IntValue"
                          />
                        </b-form-group>
                        <b-form-group
                          :label="'Decimal Value'"
                          label-for="'decimal-value"
                          label-class="font-medium-5"
                          class=""
                        >
                          <b-form-input
                            id="decimal-value"
                            v-model="tagsInfoData.DecimalValue"
                          />
                        </b-form-group>
                      </div>
                      <div>
                        <label for="valid-from-date" class="font-medium-5">
                          Date Time
                        </label>
                        <div class="d-flex">
                          <div
                            class="
                              col
                              p-0 p-relative
                              mr-2
                            "
                          >
                            <calendar-picker-icon
                              class="icon-calendar bypass"
                              :class="
                                validFrom.date ? 'date-selected-icon' : null
                              "
                            />
                            <flat-pickr
                              :id="'valid-from-date'"
                              v-model="validFrom.date"
                              class="form-control  bg-date"
                              :class="validFrom.date ? 'date-selected' : null"
                              :config="flatpickrDateConfig"
                              placeholder="-select-"
                              autocomplete="off"
                              @on-open="onOpenValidFromDatePicker"
                              @on-change="onSelectValidFromDate"
                            />
                          </div>
                          <div class="col p-0 p-relative">
                            <clock-picker-icon
                              class="icon-calendar date-picker-icon bypass"
                              :class="
                                validFrom.time ? 'date-selected-icon' : null
                              "
                            />
                            <flat-pickr
                              id="valid-from-time"
                              v-model="validFrom.time"
                              class="form-control  bg-date"
                              :class="validFrom.time ? 'date-selected' : null"
                              :config="flatpickrTimeConfig"
                              :placeholder="'-select-'"
                              autocomplete="off"
                              @on-open="onOpenValidFromTimePicker"
                              @on-change="onSelectValidFromTimePicker"
                            />
                          </div>
                        </div>
                      </div>
                      <div class="mt-2">
                        <span class="font-medium-5">{{ "Bool Value" }} </span>
                        <b-form-checkbox
                          v-model="tagsInfoData.isBoolValue"
                          class="custom-control-success custom-toggle mt-1"
                          name="check-button"
                          switch
                        >
                          <span class="switch-icon-left toggle-text">{{
                            "True"
                          }}</span>
                          <span class="switch-icon-right toggle-text">{{
                            "False"
                          }}</span>
                        </b-form-checkbox>
                      </div>
                      <div>
                        <b-form-group
                          :label="'Extra Payload'"
                          label-for="extra-payload"
                          label-class="font-medium-5"
                          class="mt-1"
                        >
                          <b-form-textarea
                            id="extra-payload"
                            v-model="tagsInfoData.ExtraPayload"
                            no-resize
                            rows="3"
                          />
                        </b-form-group>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </b-card>
        <div class="privilege-btn-wrp mt-4 mb-2">
          <div class="d-flex justify-content-center">
            <cancel-button
              class="mr-2"
              @click.native="$router.push('/tags/list')"
            />
            <save-button type="submit" class="ml-1" />
          </div>
        </div>
      </b-col>
    </b-row>
  </b-form>
</template>

<script>
import CalendarPickerIcon from "@/@core/components/svg/common/CalendarPicker.vue";
import ClockPickerIcon from "@/@core/components/svg/common/ClockPicker.vue";
import flatPickr from "vue-flatpickr-component";
import useTagsInfo from "./hooks/useTagsInfo";

export default {
  components: { CalendarPickerIcon, ClockPickerIcon, flatPickr },

  setup() {
    const {
      tagsInfoData,
      validFrom,
      validThrough,
      flatpickrDateConfig,
      flatpickrTimeConfig,
      onOpenValidFromDatePicker,
      onOpenValidFromTimePicker,
      onOpenValidThroughTimePicker,
      onSelectValidFromDate,
      onSelectValidFromTimePicker,
      onSubmitForm,
      onInputTagName,
    } = useTagsInfo();

    return {
      tagsInfoData,
      CalendarPickerIcon,
      ClockPickerIcon,
      flatPickr,
      validFrom,
      validThrough,
      flatpickrDateConfig,
      flatpickrTimeConfig,
      onOpenValidFromDatePicker,
      onOpenValidFromTimePicker,
      onOpenValidThroughTimePicker,
      onSelectValidFromDate,
      onSelectValidFromTimePicker,
      onSubmitForm,
      onInputTagName,
    };
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-flatpicker.scss";
</style>

<style scoped>
@import "~@/assets/css/pages/data-management.css";
@import "~@/assets/css/override-styles/dynamic-fields.css";
</style>
